/**
 * 404 — the catch-all route. Hand-authored (not a manifest page): a warm,
 * person-first dead-end that points back to something real. Renders inside
 * MarketingLayout (nav + footer) via the App's `path="*"` route.
 */
import { useEffect } from "react";
import { Hero } from "@inferrex/ui/marketing";

export function NotFound() {
  useEffect(() => {
    document.title = "Page not found — Inferrex";
  }, []);

  return (
    <Hero
      eyebrow="/ 404"
      title="Hmm — even we couldn't *infer* this one."
      subtitle="That page doesn't exist (or it moved). Let's get you back to something real."
      ctas={[
        { label: "Take me home", href: "/" },
        { label: "See it work", href: "/demo", variant: "outline" },
      ]}
    />
  );
}
